import { render, staticRenderFns } from "./virtualAdminReport.vue?vue&type=template&id=2db266e8&"
import script from "./virtualAdminReport.vue?vue&type=script&lang=js&"
export * from "./virtualAdminReport.vue?vue&type=script&lang=js&"
import style0 from "./virtualAdminReport.vue?vue&type=style&index=0&id=2db266e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports